import { memo } from "react";
import BriefDescriptionPhoto from "../assets/img/Desktop/Meteor_scholarship_3_D.png";
import BriefDescriptionMobilePhoto from "../assets/img/Mobile/Meteor_scholarship_3_M.png";
import ApplyLinkButton from "./ApplyLinkButton";
import MaxWidthLayout from "./MaxWidthLayout";

const BriefDescription = () => {
  return (
    <MaxWidthLayout>
      <div className="flex w-90% md:w-80% m-auto justify-between items-center mt-64px md:mt-112px text-center xl:text-start text-black-1">
        <img
          src={BriefDescriptionPhoto}
          alt="說明配的圖片"
          className="w-48% hidden xl:inline-block"
        />
        <div className=" w-full xl:w-48% flex xl:block flex-col items-center">
          <h2 className="text-green-1 text-26px md:text-4xl font-semibold pb-24px">
            第四屆 Meteor 獎學金
          </h2>
          <img
            src={BriefDescriptionMobilePhoto}
            alt="說明配的圖片"
            className="xl:hidden mb-16px"
          />
          <p className="text-14px md:text-xl pb-16px max-w-630px">
            為鼓勵成績優異的同學在學業上精益求精、奮發上進不畏風雨的表現，並在
            Meteor
            板上分享自身學習經驗，讓全台各校學生得以透過網路科技的便捷彼此交流、互相砥礪，促進學業間的良性討論、提升學生論壇的價值。
          </p>
          <p className="text-14px md:text-xl text-green-1 pb-24px md:pb-32px">
            即日起收件至2023年10月11日
          </p>
          <ApplyLinkButton />
        </div>
      </div>
    </MaxWidthLayout>
  );
};

export default memo(BriefDescription);
